// This should match the height specified in section-header.scss
export const kSectionHeaderHeight = 26;
